import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LeftOutlined } from '@ant-design/icons';
import {
  Alert, Button, Modal, Space, Typography,
} from 'antd';
import { selectBookingData } from '../../../redux/slices/booking';
import { ContainerWithForm } from '../../../components/Container';
import {
  PHN_REFERER_DETAILS, PHN_DOCUMENTS, PHN_THANKS, PHN_DOCTORS_ROUTE,
} from '../../../constants/routes';
import { getPrivateGpDetailsConfig } from '../../../config/privateBooking';
import { BookingSummaryDetails } from '../../../components/BookingSummaryDetails';
import { RequestStatus } from '../../../model';
import { createWorkflow } from '../../../services/workflow';

const HncConfirmation = () => {
  const bookingData = useSelector(selectBookingData);
  const navigate = useNavigate();
  const { search } = useLocation();
  const { showReferrerDetailsPage } = getPrivateGpDetailsConfig();
  const backRoute = showReferrerDetailsPage ? PHN_REFERER_DETAILS : PHN_DOCUMENTS;
  const searchParams = new URLSearchParams(search);
  const code = searchParams.get('code') ?? '';

  const [bookingStatus, setBookingStatus] = useState(RequestStatus.DEFAULT);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const showTimeSlotConflictModal = useCallback(() => {
    Modal.warning({
      title: 'This time slot is no longer available',
      content: 'Sorry, the appointment time you selected has just been booked by someone else. '
        + 'Please go back and choose another available time.',
      okText: 'Choose another time',
      centered: true,
      onOk: () => navigate(`${PHN_DOCTORS_ROUTE}${search}`),
    });
  }, [navigate, search]);

  // useEffect(() => {
  //   analytics.logPageViewEvent(CONFIRM_BOOKING, {
  //     site: SITE_NAME,
  //     page_path: pathname,
  //   });
  // }, [pathname]);

  const handleSubmit = useCallback(async (): Promise<RequestStatus> => {
    setBookingStatus(RequestStatus.LOADING);
    setErrorMessage(null);
    // analytics.trackVpcFormSubmit({
    //   form_id: bookingData.formId,
    //   page_path: pathname,
    //   timestamp: moment().tz('Australia/Melbourne'),
    // });

    try {
      const response = await createWorkflow(bookingData, code);
      setBookingStatus(response.status);

      // if (response.status === RequestStatus.SUCCESS && response.data) {
      //   analytics.trackVpcBookingSuccess({
      //     booking_id: response.data.toString(),
      //     timestamp: moment().tz('Australia/Melbourne'),
      //   });
      // } else {
      //   analytics.trackVpcFormError({
      //     form_id: bookingData.formId,
      //     error_type: 'book_appointment_failed',
      //     page_path: pathname,
      //   });
      // }

      return response.status;
    } catch (error) {
      setBookingStatus(RequestStatus.FAILURE);
      // analytics.trackVpcFormError({
      //   form_id: bookingData.formId,
      //   error_type: error,
      //   page_path: pathname,
      // });

      return RequestStatus.FAILURE;
    }
  }, [bookingData, code]);

  return (
    <ContainerWithForm>
      <BookingSummaryDetails bookingData={bookingData} />

      {errorMessage && <Typography.Paragraph type="danger">{errorMessage}</Typography.Paragraph>}

      <Space size="large" style={{ marginTop: '50px' }}>
        <Link to={`${backRoute}${search}`}>
          <LeftOutlined />
          Back
        </Link>
        <Button
          disabled={bookingStatus === RequestStatus.SUCCESS}
          shape="round"
          type="primary"
          onClick={async () => {
            const status = await handleSubmit();
            if (status === RequestStatus.SUCCESS) {
              navigate(`${PHN_THANKS}${search}`);
            } else if (status === RequestStatus.CONFLICT) {
              showTimeSlotConflictModal();
            }
          }}
          loading={bookingStatus === RequestStatus.LOADING}
        >
          Submit
        </Button>
      </Space>
      {
        [RequestStatus.FAILURE, RequestStatus.SUCCESS].includes(bookingStatus) && (
        <Alert
          style={{ marginTop: '20px' }}
          message={`Submit ${bookingStatus === RequestStatus.SUCCESS ? 'success' : 'failure'}`}
          type={bookingStatus === RequestStatus.SUCCESS ? 'success' : 'error'}
        />
        )
       }
    </ContainerWithForm>
  );
};

export default HncConfirmation;
